import React from 'react';
import styled from 'styled-components'
import { Row, Column as BsColumn } from 'react-foundation'

export const TwoColumnLayout = styled(Row)`
`;

export const Column = styled(BsColumn)`
`;

Column.defaultProps = {
	small: 12,
	large: 6,
};

export const Section: React.FC<{}> = (props: { children?: React.ReactNode }) => (
	<div className="form-content-fields">
		{React.Children.toArray(props.children)}
	</div>
);

export const SectionBlock: React.FC<{}> = (props: { children?: React.ReactNode }) => (
	<div className="form-content-field">
		{React.Children.toArray(props.children)}
	</div>
);

export const SectionTitle: React.FC<{}> = (props: { children?: React.ReactNode }) => (
	<div className="form-sub-header">
		{React.Children.toArray(props.children)}
	</div>
);